import { render, staticRenderFns } from "./VFormDesigner.vue?vue&type=template&id=10348144&scoped=true"
import script from "./VFormDesigner.vue?vue&type=script&lang=js"
export * from "./VFormDesigner.vue?vue&type=script&lang=js"
import style0 from "./VFormDesigner.vue?vue&type=style&index=0&id=10348144&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10348144",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10348144')) {
      api.createRecord('10348144', component.options)
    } else {
      api.reload('10348144', component.options)
    }
    module.hot.accept("./VFormDesigner.vue?vue&type=template&id=10348144&scoped=true", function () {
      api.rerender('10348144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/components/VFormDesigner.vue"
export default component.exports